import { Modal, Typography } from 'antd';
import { Product, useProducts } from '@hooks';

const { Paragraph } = Typography;

interface DeleteProductModalProps {
  open: boolean;
  onCancel: () => void;
  product: Product | null;
  onSuccess: () => void;
}

export const DeleteProductModal = ({ open, onCancel, product, onSuccess }: DeleteProductModalProps) => {
  const { deleteProduct } = useProducts();

  const handleDelete = async () => {
    if (product) {
      try {
        await deleteProduct.mutateAsync(product.id);
        onSuccess();
      } catch (error) {
        console.error('Error deleting product:', error);
      }
    }
  };

  return (
    <Modal
      title={
        <span className="font-orator text-orangicide text-xl">
          CONFIRM DELETE
        </span>
      }
      open={open}
      onCancel={onCancel}
      onOk={handleDelete}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{
        loading: deleteProduct.isPending,
        className: 'font-orator',
        style: { 
          backgroundColor: '#dc2626', 
          borderColor: '#dc2626', 
          color: '#ffffff',
        },
        onMouseEnter: (e) => {
          e.currentTarget.style.backgroundColor = '#b91c1c';
          e.currentTarget.style.borderColor = '#b91c1c';
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.backgroundColor = '#dc2626';
          e.currentTarget.style.borderColor = '#dc2626';
        },
      }}
      cancelButtonProps={{
        className: 'font-orator',
        style: { 
          backgroundColor: 'transparent', 
          borderColor: '#6b7280', 
          color: '#9ca3af',
        },
        onMouseEnter: (e) => {
          e.currentTarget.style.borderColor = '#9ca3af';
          e.currentTarget.style.color = '#d1d5db';
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.borderColor = '#6b7280';
          e.currentTarget.style.color = '#9ca3af';
        },
      }}
      styles={{
        mask: { backdropFilter: 'blur(10px)', backgroundColor: 'rgba(0,0,0,0.7)' },
        content: { backgroundColor: '#181717', border: '1px solid #3f3f46', borderRadius: '0px' },
        header: { backgroundColor: '#181717', borderBottom: '1px solid #3f3f46' },
        footer: { backgroundColor: '#181717', borderTop: '1px solid #3f3f46', padding: '16px 24px' },
      }}
    >
      <div className="py-4">
        <Paragraph className="font-orator text-white text-lg">
          Are you sure you want to delete the product "{product?.name}"?
        </Paragraph>
        <Paragraph className="font-orator text-white">
          This action cannot be undone. The product will be permanently removed from your catalog.
        </Paragraph>
      </div>
    </Modal>
  );
};
